import { StatusTypeList } from "constants/status";
import { OrderActionType, ParcelAction, ParcelActionType } from "data/types";

export const parcelsAndOrdersReducer = (state: any, action: ParcelAction): any => {
  if (!Array.isArray(action.data)) {
    return state;
  }
  switch (action.type) {
    case ParcelActionType.FetchParcels:
    case ParcelActionType.FetchParcelsByStatus:
      state.parcels[action.statusKey] = [];
      return {
        ...state,
        parcels: {
          ...state.parcels,
          [action.statusKey]: updateList(state.parcels[action.statusKey], action.data),
        },
      };
    case ParcelActionType.UpdateParcels:
      return {
        ...state,
        parcels: {
          ...dataDispatcher(state.parcels, action.data, "parcel_status"),
        },
      };
    case ParcelActionType.RemoveParcels:
      return {
        ...state,
        parcels: {
          ...removeData(state.parcels, action.data),
        },
      };
    case OrderActionType.FetchOrders:
    case OrderActionType.OrderByStatus:
      state.orders[action.statusKey] = [];
      return {
        ...state,
        orders: {
          ...state.orders,
          [action.statusKey]: updateList(state.orders[action.statusKey], action.data),
        },
      };
    case OrderActionType.UpdateOrders:
      return {
        ...state,
        orders: {
          ...dataDispatcher(state.orders, action.data, "order_status"),
        },
      };
    case OrderActionType.RemoveOrders:
      return {
        ...state,
        orders: {
          ...removeData(state.orders, action.data),
        },
      };
    default:
      return state;
  }
};

// enlever les elements de la liste, et mettre remettre leurs versions modifiées en tête de liste
export const updateList = (values: any[], updated: any[]): any[] => {
  const list = filterList(values, updated);
  list.unshift(...updated);
  return list;
};

const filterList = (values: any[], data: any[]) =>
  values?.filter((element) => !data.find((u) => u._id === element._id));

type StatusProperty = "order_status" | "parcel_status" | "subtask_status";

export const getDataStatusKey = (data: any, property: StatusProperty) => {
  const conf = StatusTypeList[property];
  const status = data[property];
  return Object.keys(conf.list).find((key) => conf.list[key].includes(status)) || conf.default;
};

export const removeData = (data: any, removed: any[]) => {
  Object.keys(data).forEach((key) => (data[key] = filterList(data[key], removed)));
  return data;
};

export const dataDispatcher = (container: any, data: any[], property: StatusProperty) => {
  const statusKeyData = data.reduce((map, element) => {
    const key = getDataStatusKey(element, property);
    const array = map[key] || [];

    array.push(element);
    map[key] = array;
    return map;
  }, {});

  Object.keys(container).forEach((key) => {
    const list = filterList(container[key], data);
    statusKeyData[key] = statusKeyData[key] ? updateList(list, statusKeyData[key]) : list;
  });

  return statusKeyData;
};
